import { TranslateFunc } from 'components/translate/src/translate-func';
import { ClientMarket } from 'config/types/client-market';

type VariantSelection = string[] | null;

export const getSizeTitle = (t: TranslateFunc, market: ClientMarket) => {
  return `${t('product', 'label.size')} (${
    market.productVariants?.shoeSizeStandard
  })`;
};

export const createNewSelection = (
  variant: string | null,
  variantSelection: VariantSelection
) => {
  const currentSelection = variantSelection ?? [];
  if (!variant) {
    return null;
  }
  const newSelection = currentSelection.includes(variant)
    ? currentSelection.filter((v: string) => v !== variant)
    : [...currentSelection, variant];
  return newSelection.length ? newSelection : null;
};
